import { render } from "./SpecialDayIndex.vue?vue&type=template&id=7f0b6062"
import script from "./SpecialDayIndex.vue?vue&type=script&lang=js"
export * from "./SpecialDayIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__